import moment from 'moment';

type HeadLike = { killDate?: string | null };

export function getLatestKillDate(
  heads: Array<HeadLike | null | undefined> | null | undefined,
): string | undefined {
  return heads
    ?.map((h) => h?.killDate)
    .filter((d): d is string => !!d)
    .sort((a, b) => moment(b).valueOf() - moment(a).valueOf())[0];
}
